export default "__VITE_ASSET__49c53976__"